"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _classNames2 = _interopRequireDefault(require("../../util/classNames"));

var _Button = _interopRequireDefault(require("../Button/Button"));

require("./AdminModal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AdminModal = function AdminModal(_ref) {
  var isOpen = _ref.isOpen,
      toggle = _ref.toggle,
      size = _ref.size,
      title = _ref.title,
      subtitle = _ref.subtitle,
      bordered = _ref.bordered,
      borderedFooter = _ref.borderedFooter,
      largeHeader = _ref.largeHeader,
      locked = _ref.locked,
      className = _ref.className,
      onConfirm = _ref.onConfirm,
      confirmLabel = _ref.confirmLabel,
      disabledConfirm = _ref.disabledConfirm,
      onCancel = _ref.onCancel,
      cancelLabel = _ref.cancelLabel,
      onClose = _ref.onClose,
      children = _ref.children;
  var classes = (0, _classNames2["default"])(_defineProperty({
    'gcl-bordered': bordered
  }, 'gcl-' + size, true));
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    isOpen: isOpen,
    toggle: locked ? undefined : toggle,
    className: "".concat(classes, " ").concat(className),
    onClosed: onClose,
    centered: true,
    scrollable: true
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalHeader, {
    className: largeHeader ? 'gcl-large' : '',
    close: /*#__PURE__*/_react["default"].createElement("i", {
      className: "gcl-icon close",
      onClick: toggle
    })
  }, title, subtitle != null && /*#__PURE__*/_react["default"].createElement("h6", {
    className: "gcl-subtitle"
  }, subtitle)), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, null, children), (onCancel || onConfirm) && /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, {
    className: borderedFooter ? 'gcl-bordered' : ''
  }, onCancel && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onCancel
  }, cancelLabel), onConfirm && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    onClick: onConfirm,
    disabled: disabledConfirm
  }, confirmLabel)));
};

AdminModal.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  toggle: _propTypes["default"].func.isRequired,
  size: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  bordered: _propTypes["default"].bool,
  borderedFooter: _propTypes["default"].bool,
  largeHeader: _propTypes["default"].bool,
  locked: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  onConfirm: _propTypes["default"].func,
  confirmLabel: _propTypes["default"].string,
  disabledConfirm: _propTypes["default"].bool,
  onCancel: _propTypes["default"].func,
  cancelLabel: _propTypes["default"].string,
  onClose: _propTypes["default"].func
};
AdminModal.defaultProps = {
  size: 'md',
  bordered: false,
  locked: false,
  disabledConfirm: false,
  className: ''
};
var _default = AdminModal;
exports["default"] = _default;